export const PROFILE_UPDATED_EVENT = 'profile-updated';
